module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
 ** module id = 5
 ** module chunks = 0
 **/